/*

Raghu 27/10/2022 3225736869 Inputfields and Button Alignment Fixes
Lalitha 10/27/2022 3225736869 night jobs UX changes
Prakash 10/31/2022 3225736869 added classname for buttons and styling for Accordion.
Poornima 12/07/2022 3225736869 renamed search night jobs
Sohel 02/10/2022 3225736869 night jobs validation changes
sohel 03/06/2023 3225736869 Added validation message for existing value
Suresh Peddavoora 03/20/2023 3225736869 Removed Classnames for textfields

*/
import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  FormControl,
  Tooltip,
} from '@material-ui/core';
import React, {useState, useEffect, useContext} from 'react';
import DialogBox from '../../../../../components/DialogBox';
import AddTaskForm from './AddTaskForm';
import TaskTable from './TaskTable';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import Schedules from './Schedules';
import SystemNotes from './SystemNotes';
import AddIcon from '@material-ui/icons/Add';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import {ArrowBack} from '@material-ui/icons';
import {postAddNightJob, fetchAllJobCodesAndJobNames, resetMessage, resetStatus} from './../../../../../redux/reducers/NightJobs/AddNightJob';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
const RuleGroup1 = ({roleDataNJobs, setValue, setTabValue, nightJobCode, isCopyRowData}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const {isLoading, successMsg, errorMsg, addNightJobStatus, nightJobData, addNightJob, allJobCodesAndJobNames} =
    useSelector(({addNightJob}) => addNightJob);

  const [deletedRules, setDeletedRules] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowData, setRowData] = useState({});
  const [oldRuleCode, setOldRuleCode] = useState('');
  const [expanded, setExpanded] = useState();
  const statuses = [
    {key: 'Scheduled', value: 'Scheduled'},
    {key: 'Waiting', value: 'Waiting'},
  ];
  const getSelectObject = (options, option) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.key === option) {
          label = item;
        }
      });
    return label;
  };

  useEffect(() => {
    dispatch(fetchAllJobCodesAndJobNames());
  }, []);

  const checkJobCodeExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if ((i?.jobCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) && i?.isActive === 'Y') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkJobCodeAlreadyExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if ((i?.jobCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) && i?.isActive === 'N') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkJobNameExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if ((i?.jobName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) && i?.isActive === 'Y') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkJobNameAlreadyExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if ((i?.jobName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) && i?.isActive === 'N') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const initialValues = {
    code: isCopyRowData ? '' : nightJobData?.jobCode || '',
    jobName: nightJobData?.jobName || '',
    description: nightJobData?.jobDescription || '',
    status: nightJobData?.jobStatus ? getSelectObject(statuses, nightJobData?.jobStatus) : '',
    expression: nightJobData?.scheduleExpression || '',
  };

  const validationSchema = Yup.object().shape({
    code: initialValues.code ?
      '' :
      Yup.string()
        .test('code', 'Job Code already exist', (value) => !checkJobCodeExist(value))
        .test('code', 'Job Code has already been used in the past', (value) => !checkJobCodeAlreadyExist(value))
        .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed')
        .required('Job Code is required'),
    jobName: Yup.string()
      .test('jobName', 'Job Name already exist', (value) => !checkJobNameExist(value))
      .test('code', 'Job Name has already been used in the past', (value) => !checkJobNameAlreadyExist(value))

      .required('Job name is required'),
    description: Yup.string().required('Job description is required'),
    status: Yup.mixed().test('status', 'Job status is required', (value) => {
      if (!value?.key) {
        return false;
      } else {
        return true;
      }
    }),
    expression: Yup.string().required('Schedule expression is required'),
  });

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
  };

  const {register, handleSubmit, reset, control, errors, watch} = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    if (Object.keys(nightJobData).length > 0) {
      reset(initialValues);
      const ruleData =
        nightJobData.tasks &&
        nightJobData.tasks.map((data) => {
          const newObj = {
            ...data,
            id: data.id,
            taskCode: data.code,
            taskType: data.type,
            parameters: data.parameters,
            tableData: {checked: true, id: data.jobId},
          };
          return newObj;
        });
      const sortedData = [...ruleData];
      sortedData.sort((a, b) => a['sequence'] - b['sequence']);
      setFormData(sortedData);
    }
  }, [nightJobData]);

  useEffect(() => {
    if (addNightJobStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2000);
      dispatch(resetStatus());
      reset({});
      setValue(0);
      setFormData([]);
    }
  }, [addNightJobStatus]);

  useEffect(() => {
    if (addNightJob === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
    }
  }, [addNightJob]);

  const handleScheduleClose = () => {
    setScheduleOpen(false);
  };
  // const onSubmit = (data) => {
  //   if (data) {
  //     const passValues = {
  //       tasks: formData.map((item, index) => {
  //         return {
  //           id: item?.id || 0,
  //           code: item.taskCode,
  //           type: item.taskType,
  //           parameters: item.parameters,
  //           sequence: index,
  //         };
  //       }),
  //       jobCode:isCopyRowData ? data?.code?.toUpperCase() : nightJobData?.jobCode
  //         ? nightJobData.jobCode.toUpperCase()
  //         : data?.code
  //           ? data.code.toUpperCase()
  //           : "",
  //       id: isCopyRowData ? 0 : nightJobData?.id || 0,
  //       jobDescription: data.description,
  //       jobName: data.jobName,
  //       jobStatus: data?.status?.key ? data.status.key : "",
  //       scheduleExpression: data.expression,
  //     };
  //     dispatch(postNightJob(passValues));
  //   }
  // };

  const onSubmit = (data) => {
    const passValues = {
      'taskRequest': formData.map((item, index) => {
        return {
          taskId: 0,
          jobCode: '',
          tasktType: item.taskType,
          taskParameters: item.parameters,
          seqNo: 0,
          taskCode: item.taskCode,
        };
      }),
      'jobCode': data?.code,
      'jobConfigId': null,
      'jobDescription': data?.description,
      'jobName': data?.jobName,
      'jobStatus': data?.status?.value,
      'scheduleExpression': data?.expression,
      'deleteTaskIds': [],
    };
    dispatch(postAddNightJob(passValues));
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            disabled={isLoading || successMsg}
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
            Search Scheduled Jobs
          </Button>
        </div>
        <div>
          <div className="form-row global-field-textfields new-standard-textfields">
            <div className="col-sm-6 col-md-4 col-lg-3 form-group">
              <TextField
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter Job Code"
                margin="dense"
                name="code"
                value={watch('code')?.toUpperCase()}
                variant="outlined"
                label="Job Code"
                disabled={nightJobData?.jobCode && !isCopyRowData}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                required
                inputRef={register}
                fullWidth
                error={Boolean(errors.code?.message)}
              />
              <FormHelperText variant="outlined">
                {errors.code?.message ? errors.code.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 form-group">
              <TextField
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter Job Name"
                margin="dense"
                name="jobName"
                variant="outlined"
                label="Job Name"
                defaultValue={initialValues.jobName}
                required
                // InputLabelProps={{
                //   shrink: true,
                // }}
                inputRef={register}
                fullWidth
                error={Boolean(errors.jobName?.message)}
              />
              <FormHelperText variant="outlined">
                {errors.jobName?.message ? errors.jobName.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 form-group">
              <TextField
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter Job Description"
                margin="dense"
                name="description"
                variant="outlined"
                label="Job Description"
                defaultValue={initialValues.description}
                required
                // InputLabelProps={{
                //   shrink: true,
                // }}
                inputRef={register}
                fullWidth
                error={Boolean(errors.description?.message)}
              />
              <FormHelperText variant="outlined">
                {errors.description?.message ? errors.description.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="status"
                      options={statuses}
                      size="small"
                      autoHighlight
                      getOptionDisabled={(option) => option.valueCode === null}
                      getOptionLabel={(option) => {
                        return option?.value ? option.value : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          // className={` ${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="outlined"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          fullWidth
                          required
                          error={Boolean(errors.status?.message)}
                          label="Job Status"
                          name="status"
                          placeholder="Select Job Status"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="status"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.status?.message ? errors.status.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 form-group">
              <TextField
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter Schedule Expression"
                margin="dense"
                name="expression"
                variant="outlined"
                label="Schedule Expression"
                defaultValue={initialValues.expression}
                required
                // InputLabelProps={{
                //   shrink: true,
                // }}
                inputRef={register}
                fullWidth
                error={Boolean(errors.expression?.message)}
              />
              <FormHelperText variant="outlined">
                {errors.expression?.message ? errors.expression.message : ''}
              </FormHelperText>
            </div>
            {nightJobCode && (
              <div className="col-sm-4">
                <Button
                  variant="contained"
                  onClick={() => setScheduleOpen(true)}
                  className={`themeing-buttons mt-2 ${classes.buttonRoot}`}
                >
                  View Schedules
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className={`mt-2`}>
          <div className="table-header table-card-header new-standard-textfields">
            <Typography variant="h4">Tasks</Typography>
            <Button
              variant="outlined"
              className={`search-btn ${classes.buttonRoot}`}
              onClick={() => {
                setOpen(true);
              }}
            >
              <AddIcon />
              Add Task
            </Button>
          </div>
          <TaskTable
            setIsEditMode={setIsEditMode}
            setOldRuleCode={setOldRuleCode}
            setRowData={setRowData}
            rowData={rowData}
            setOpen={setOpen}
            formData={formData}
            setFormData={setFormData}
            deletedRules={deletedRules}
            setDeletedRules={setDeletedRules}
            nightJobCode={nightJobCode}
          />
        </div>
        <div className="row justify-content-center mt-3 new-standard-textfields">
          <Button
            type="button"
            onClick={() => {
              reset(initialValues);
            }}
            variant="outlined"
            className={`mr-1 reset-btn ${classes.buttonRoot}`}
          >
            Reset
          </Button>
          {(Object.keys(nightJobData).length > 0 ? roleDataNJobs?.edit : roleDataNJobs?.add) &&
          formData &&
          formData?.length > 0 ? (
              <Button
                type="submit"
                variant="outlined"
                className={`ml-1 search-btn ${classes.buttonRoot}`}
                color="primary"
              >
              Save
              </Button>
            ) : (
              <Tooltip title="Please add atleast one task to continue">
                <span>
                  <Button
                    type="submit"
                    variant="outlined"
                    className={`ml-1 search-btn ${classes.buttonRoot}`}
                    color="primary"
                    disabled
                  >
                  Save
                  </Button>
                </span>
              </Tooltip>
            )}
        </div>
        <DialogBox
          open={open || isEditMode}
          dialogClose={handleClose}
          hideFooter={true}
          maxWidth={'md'}
          title={(isEditMode && 'Edit Task ') || (open && 'Add Task')}
        >
          <AddTaskForm
            rowData={rowData}
            setFormData={setFormData}
            formData={formData}
            setOpen={setOpen}
            handleClose={handleClose}
            isEditMode={isEditMode}
            oldRuleCode={oldRuleCode}
            setIsEditMode={setIsEditMode}
          />
        </DialogBox>
        <DialogBox
          open={scheduleOpen}
          dialogClose={handleScheduleClose}
          hideFooter={true}
          title={'Schedules '}
          maxWidth={'lg'}
        >
          <Schedules />
        </DialogBox>
      </form>
      {nightJobCode && (
        <div className={`${classes1.root} mt-3`}>
          <Accordion
            className="accordion-styling"
            expanded={expanded === 'panel1'}
            onChange={handleAccordionChange('panel1')}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography className={classes1.heading}>Night Jobs Notes</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes1.detailsCard}>
              <SystemNotes nightJobCode={nightJobCode} />
            </AccordionDetails>
          </Accordion>
        </div>
      )}
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default RuleGroup1;
